import { Check, Close, ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import { AccordionPersonForm } from 'shell/view-models/accordion-person-form';
import { Fragment, memo, useCallback, useMemo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import {
  SubscriptionAccordionGenerality,
  CommonInterfaceSubscription,
} from 'subscription/view-models/common-interface-subscription';
import FormGenerality from './form';

interface AccordionGeneralityProps {
  disabled?: boolean;
  isEditMode?: boolean;
  isCohabitation?: boolean;
  isAire?: boolean;
  isTransferNew?: boolean;
  nonResident?: boolean;
  isFromCivilStatus?: boolean;
  isSubscription?: boolean;
}

const AccordionGeneralityComponent = ({
  disabled = false,
  isCohabitation = false,
  isAire = false,
  isTransferNew,
  nonResident,
  isFromCivilStatus,
  isSubscription = false,
}: AccordionGeneralityProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  const formContext = useFormikContext<CommonInterfaceSubscription>();

  const onFieldGeneralityChange = useCallback(
    (key, value) => {
      formContext.setFieldValue('generality', {
        ...formContext.values.generality,
        [key]: value,
      });
    },
    [formContext.values.generality, formContext.setFieldValue]
  );

  const onChangeValues = useCallback(
    (values) => {
      formContext.setFieldValue('generality', {
        ...formContext.values.generality,
        ...(values || {}),
      });
    },
    [formContext.values.generality, formContext.setFieldValue]
  );

  // const onFieldPersonChange = useCallback(
  //   (key, value) => {
  //     formContext.setFieldValue('person', {
  //       ...formContext.values.person,
  //       [key]: value,
  //     });
  //   },
  //   [formContext.values.person, formContext.setFieldValue]
  // );

  const resetForm = useCallback(() => {
    formContext.setValues({
      ...formContext.values,
      person: {
        ...formContext.initialValues?.person,
      },
      generality: {
        ...formContext.initialValues?.generality,
      },
    });
  }, [formContext.values, formContext.setValues, formContext.initialValues]);

  const errorGeneralityPerson = useMemo(() => {
    return !!formContext.errors.person || !!formContext.errors.generality;
  }, [formContext.errors.person, formContext.errors.generality]);

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="panel-generality-content"
          id="panel-generality-header"
          expandIcon={<ExpandMore />}
        >
          {errorGeneralityPerson ? <Close color="error" /> : <Check color="success" />}
          <Typography>Generalità</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FormGenerality
            isCohabitation={isCohabitation}
            disabled={disabled || isTransferNew}
            onChangeGenerality={onFieldGeneralityChange}
            onChangeValues={onChangeValues}
            nonResident={nonResident}
            generality={formContext.values.generality}
            editDataControlFlag={formContext.values.editDataControl?.flag}
            errorsGenerality={
              formContext.errors.generality as FormikErrors<SubscriptionAccordionGenerality>
            }
            errorsPerson={formContext.errors.person as FormikErrors<AccordionPersonForm>}
            touchedPerson={
              formContext.touched.person as unknown as FormikTouched<AccordionPersonForm>
            }
            touchedGenerality={
              formContext.touched
                .generality as unknown as FormikTouched<SubscriptionAccordionGenerality>
            }
            resetForm={resetForm}
            isAire={isAire}
            isFromCivilStatus={isFromCivilStatus}
            isDeathPerson={isSubscription}
          />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

AccordionGeneralityComponent.displayName = 'Accordion generality component';

const AccordionGenerality = memo(AccordionGeneralityComponent);

export default AccordionGenerality;
